<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 align-items">
      <div>产品赠送</div>
      <el-button type="primary" @click="addClick()" v-perm="{key:'shopGift', value:'shopGift:add'}">赠送登记</el-button>
    </div>
    <div class="page-head">
      <div class="mains-content br10">
        <div class="member-content-box">
          <div class="member-header">
            <div class="flex-row">
              <el-select v-model="query.orderStatus" class="select" placeholder="订单状态" filterable>
                <el-option label="全部状态" value></el-option>
                <el-option label="已完成" value="finish"></el-option>
                <el-option label="已作废" value="invalid"></el-option>
              </el-select>
              <v-date @time="changeDate" class="ml10 mr10"></v-date>
              <el-button type="primary" @click="doData">搜索</el-button>
            </div>
            
            
          </div>
          <div class="plr16" v-perm="{key:'shopGift', value:'shopGift:list'}">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="title" label="商品名称" width="auto"></el-table-column>
              <el-table-column prop="staffNames" label="店员" width="auto"></el-table-column>
              <el-table-column prop="itemNum" label="赠品数量" width="auto"></el-table-column>
              <el-table-column prop="customerName" label="顾客姓名" width="auto"></el-table-column>
              <el-table-column prop="mobile" label="手机号" width="auto"></el-table-column>
              <el-table-column prop="orderStatusCn" label="订单状态" width="auto"></el-table-column>
              <el-table-column prop="oxCtime" label="赠送时间" width="auto">
                <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                      <el-link type="primary" @click="orderDetailPage(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
    <detail-set ref="detailSetForm" @change="cancel"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
import detailSet from "./detail";
export default {
  data() {
    return {
      url: this.$url.giftOrderInfo.list,
      query: {
        orderStatus: '',
        beginTime: new Date(),
        endTime: new Date(),
        start: 0,
        size: 20
      },
      list: [],
      options: [],
      height: this.$store.getters.MainHeight,
    };
  },
  mixins: [minxin],
  components: { editSet, detailSet },
  computed: {},

  created() {
    this.totalCounts();
    this.invoiceCategory();
  },

  methods: {
    back() {
      this.$router.push("/collectMoney");
    },
    changeDate(value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      // this.getList();
    },
    invoiceCategory() {
      //发票分类
      this.$api.post(this.$url.invoiceCategory.list).then(res => {
        if (res) {
          this.options = res;
          this.options.unshift({id: "",name: "全部类型"})
        }
      });
    },
    addClick(item) {
      console.log(item)
      if (item && item.id) {
        this.$refs["editSetForm"].$emit("set", item)
      } else {
        this.$refs["editSetForm"].$emit("set")
      }
      // this.$refs["editSetForm"].$emit("set");
    },
    orderDetailPage(row) {
      this.$refs["detailSetForm"].$emit("set", row);
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.getData();
    },
    totalCounts () {
      this.$api.post(this.$url.giftOrderInfo.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    cancel(row) {
      if (row) {
        this.getData();
      } 
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  background: #fff;
  .member-header {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>

